module.exports = __webpack_public_path__ + "img/ssGreyCross.0d785623.svg";